import { SelectButton } from "primereact/selectbutton";
import { problemStatusTabs } from "../../utils/problemConstants";

const scheduleStatus = 2;
const ignoreStatus = 4;

const toggleOptions = [
  { value: scheduleStatus, label: "Schedule", icon: "pi pi-calendar" },
  { value: ignoreStatus, label: "Ignore", icon: "pi pi-ban" },
];

// Two toggle buttons of the problem status: Schedule and Ignore. They are never disabled, a solved problem can turn out not fixed.
// "Baru" and "Solved" are not buttons: a problem is Solved by its Tanggal Selesai and it never goes back to Baru,
// so with those statuses no button is on.
//   status: status of the problem, onChange(status): a button was pressed
const ProblemStatusToggle = ({ status, onChange }) => {
  const currentLabel = problemStatusTabs.find((el) => el.status === status);

  return (
    <div className="col-start-start w-100 gap-1">
      <label className="font-bold text-sm text-slate-500">Status</label>
      <SelectButton
        className="w-100"
        value={status === scheduleStatus || status === ignoreStatus ? status : null}
        options={toggleOptions}
        optionLabel="label"
        optionValue="value"
        allowEmpty={false}
        itemTemplate={(option) => (
          <span className="row-center-center gap-2">
            <i className={`${option.icon} text-xs`}></i>
            <span>{option.label}</span>
          </span>
        )}
        onChange={(e) => {
          // pressing the button that is on gives null: keep the status
          if (e.value === null || e.value === undefined) return;
          onChange(e.value);
        }}
      />
      <small className="text-slate-400">
        Status sekarang: {currentLabel ? currentLabel.label : "Baru"}
      </small>
    </div>
  );
};

export default ProblemStatusToggle;
